import { DoctorUpdateRequestPayload } from "@/data/payload/admin/doctor-update-reqeust-payload";
import { AdminRepository } from "@/domain/repository/admin-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class UpdateDoctorUsecase {
  constructor(private readonly adminRepository: AdminRepository) {}

  async execute(
    doctorUuid: string,
    name: string,
    email: string,
    hospitalCode: string,
    memo: string,
  ): Promise<SATResult<void, SATError>> {
    const payload: DoctorUpdateRequestPayload = {
      name: name,
      email: email.toLowerCase(),
      hospitalCode: hospitalCode,
      memo: memo,
    };

    const result = await this.adminRepository.updateDoctor(doctorUuid, payload);

    if (result.isSuccess) {
      console.log("[UpdateDoctorUsecase] :: execute :: 의사 정보 업데이트 성공", result.value);
      return SATResult.success(void 0);
    }

    console.log("[UpdateDoctorUsecase] :: execute :: 의사 정보 업데이트 실패", result.error);
    return SATResult.failure(result.error);
  }
}
